import { render, staticRenderFns } from "./AgreementDetails.vue?vue&type=template&id=19072f3e&scoped=true&"
import script from "./AgreementDetails.vue?vue&type=script&lang=js&"
export * from "./AgreementDetails.vue?vue&type=script&lang=js&"
import style0 from "./AgreementDetails.vue?vue&type=style&index=0&id=19072f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19072f3e",
  null
  
)

export default component.exports